import React from "react";
import { nl } from "./nl.jsx";

// Wspólny komponent prezentacyjny sekcji HERO.
// Używany ZARÓWNO przez publiczną HomePage.jsx, JAK I przez podgląd Puck (config.jsx) — 1:1.
//
// Model nagłówka (bez "linia 1/2"): headingBefore (textarea, \n→<br/>) + wyróżniony
// fragment w <span class="hl hl-paint"> + headingAfter (opcjonalny).
// reveal: klasa .rv (animacja wejścia na stronie) — w podglądzie Puck false (od razu widoczne).
const noop = () => {};

export function HomeHero({
  eyebrow = "",
  headingBefore = "",
  headingHighlight = "",
  headingAfter = "",
  sub = "",
  primary = "",
  secondary = "",
  onPrimary = noop,
  onSecondary = noop,
  reveal = true,
}) {
  const rv = reveal ? " rv" : "";
  return (
    <section className="hero">
      <span className={"eyebrow hero-eyebrow" + rv}>{eyebrow}</span>
      <h1 className={"h-display" + rv}>
        {nl(headingBefore)}<span className="hl hl-paint">{headingHighlight}</span>{nl(headingAfter)}
      </h1>
      <p className={"hero-sub" + rv}>
        {sub}
      </p>
      <div className={"hero-ctas" + rv}>
        <button className="lc-btn lc-btn-primary lc-btn-lg" onClick={onPrimary}>
          {primary} <span className="lc-btn-arr">↗</span>
        </button>
        <button className="lc-btn lc-btn-link lc-btn-lg" onClick={onSecondary}>
          {secondary} <span className="lc-btn-arr">↗</span>
        </button>
      </div>
    </section>
  );
}
